import { FeatureFlag } from '../FeatureFlag';

/**
 * Allows Datadog Session Replay to capture grid DOM. Disabled by default because hiding a grid
 * prevents Datadog from traversing its large, frequently changing subtree.
 */
export const enableDatadogGridReplayCapture = new FeatureFlag({
    key: 'enable-datadog-grid-replay-capture',
    defaultValue: false,
});
